// extracted by mini-css-extract-plugin
export default {"contact":"ContactsPage_contact__4HmFB","title__contact":"ContactsPage_title__contact__mpe6w"};